import React, { Fragment, useEffect, useState, useContext } from "react";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { Link, withRouter } from "react-router-dom";
import { getDataById, getImage } from "./utils";
import uniqid from "uniqid";
import { MetadataAdd } from "./MetadataAdd";
import { MetadataMore } from "./MetadataMore";

export function MetadataInner(props) {
  const { videoId, history, match, location } = { ...props };
  const context = useContext(Context);

  const getMetadataCategories = (videoId) => {
    if (!videoId) return [];
    let metaArrayIds =
      getDataById(context, "videos", videoId, "metadata") || [];
    let metadataArray = metaArrayIds.map((oneId) => ({
      ...getDataById(context, "metadata", oneId),
    }));
    // console.log("metadataArray = ", metadataArray);
    let arr = [
      ...new Set(
        metadataArray.map((oneMeta) =>
          getDataById(context, "metadata", oneMeta["id"])
            ? oneMeta["typeRef"]
            : null
        )
      ),
    ];
    return arr;
    // return [...new Set(metadataArray.map((oneMeta) => getDataById(context, 'metadata', oneMeta["typeRef"]) ? oneMeta["typeRef"] : null))];
    // return metadataArray.map(oneMeta => oneMeta)
    // return metadataArray ? metadataArray : []
  };

  return (
    <>
      {getMetadataCategories(videoId).map((typeRef) => {
        return (
          <>
            <MetadataSection typeRef={typeRef} {...props} />
          </>
        );
      })}

      <MetadataAdd
        videoId={videoId}
        categoriesArray={getMetadataCategories(videoId)}
      />
    </>
  );
}

export function MetadataSection({
  videoId,
  typeRef,
  typeTitle,
  history,
  match,
  location,
}) {
  const context = useContext(Context);

  // console.log("typeRef = ", typeRef);
  let typeData = getDataById(context, "metaDataTypes", typeRef) || {};
  // console.log("typeData = ", typeData);

  const getMetadata = (videoId, typeRef) => {
    let metaArrayIds = getDataById(context, "videos", videoId, "metadata");
    let metadataArray = metaArrayIds.map((oneId) => ({
      ...getDataById(context, "metadata", oneId),
    }));
    // debugger
    // metadataArray = metadataArray.length ? metadataArray.filter(oneMetadata => oneMetadata['active']) : []
    metadataArray = metadataArray.filter((oneMeta) => {
      return typeRef && oneMeta["typeRef"] === typeRef;
    });
    return metadataArray ? metadataArray : [];
  };

  const [shown, setShown] = useState();

  return (
    <div className="l_comments_section" style={{ color: typeData["color"] }}>
      <div className="l_comments_container">
        <div className="x_meta_sticky">
          <div className="p_player_scroll_line">
            {getMetadata(videoId, typeRef).map((oneMetadata) => {
              // console.log("oneMetadata133= ", oneMetadata);
              // console.log(
              //   "oneMetadata['metaTime'] = ",
              //   oneMetadata["metaTime"]
              // );
              let metaTime = oneMetadata["metaTime"] || 0;
              return (
                <>
                  <div
                    key={uniqid()}
                    className="p_player_comment"
                    style={{
                      marginLeft: `${metaTime * 100}%`,
                      backgroundColor: typeData["color"],
                    }}
                  >
                    {typeData["emoji"]}
                  </div>
                </>
              );
            })}

            <div
              className="p_player_scroll_body"
              style={{ backgroundColor: typeData["color"] }}
            />
          </div>

          <div className="x_meta_title0" style={{ color: typeData["color"] }}>
            <div className="x_meta_tag x_meta_tag--title">
              <div className="x_meta_icon">
                <div>
                  <div className="p_player_emoji">{typeData["emoji"]}</div>
                </div>
              </div>
              <div className="x_meta_title">
                {typeData["title"]}
                <div className="x_meta_title_nums0">
                  <div className="x_meta_title_num">
                    {getMetadata(videoId, typeRef).length}
                  </div>
                </div>
                {/* <div className="x_meta_title_num x_meta_title_num--comments">
                  <div className="x_meta_comment_icon">
                    <div>comment</div>
                  </div>
                  <div>3</div>
                </div> */}
              </div>
            </div>
            <div className="x_meta_right">
              <div className="x_meta_menu">
                <div className="x_button x_button--xs"
                  style={{backgroundColor: typeData["color"]}}
                >
                  <div>Hide</div>
                  <div className="x_button_icon">
                    <div>visibility_off</div>
                  </div>
                </div>
                <div className="x_button x_button--xs"
                  style={{backgroundColor: typeData["color"]}}
                >
                  <div>Pin</div>
                  <div className="x_button_icon">
                    <div>push_pin</div>
                  </div>
                </div>
                {/* <div className="x_button x_button--xs x_button_icon"> */}
                <div className="x_button x_button--flat"><div className="x_button_icon"><div>more_vert</div></div></div>

                {/* </div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="c_player_scrub">
          <div className="c_player_container">
            <div
              className={`p_comments0 p_comments0--collapsible ${
                shown ? "shown" : ""
              }`}
            >
              {getMetadata(videoId, typeRef).length > 4 && (
                <MetadataMore handle={() => setShown(!shown)}>
                  {!shown &&
                    `Show ${
                      getMetadata(videoId, typeRef).length - 3
                    } more comments`}
                  {shown && `Hide`}
                </MetadataMore>
              )}

              <div className="c_player_comment0">
                <div className="p_comments0">
                  {getMetadata(videoId, typeRef).map((oneMetadata) => {
                    // console.log("oneMetadata = ", oneMetadata);
                    return (
                      <>
                        {oneMetadata["commentText"] && (
                          <MetadataComments {...oneMetadata} />
                        )}
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function MetadataComments(props) {
  const {
    id,
    uniq,
    type,
    author,
    authorImg,
    authorName,
    commentText,
    typeIcon,
    typeColor,
    typeTitle,
    commentParentId,
    commentParentText,
    videoId,
    videoThumb,
  } = { ...props };

  // console.log("authorImg = ", authorImg);
  return (
    <div className="p_comment0">
      <div className="p_comment_time">
        <div className="p_comment_time0">
          <div className="p_comment_time_frame p_comment_time_frame--mini">
            <img src={getImage(videoThumb)} loading="lazy" sizes="44px" alt />
          </div>
          <div className="p_comment_time_stamp">1:34</div>
        </div>
      </div>
      <div className="p_comment_right">
        <div className="p_comment p_comment--mini">
          <div href="#" className="p_user_details">
            <div>
              <div className="x_comment_title x_comment_title--mini">
                <div className="x_user_ava">
                  <img
                    src={getImage(authorImg)}
                    loading="lazy"
                    sizes="(max-width: 767px) 16px, (max-width: 991px) 2vw, 16px"
                    alt
                    className="p_user_ava_img p_user_ava_img--sm"
                  />
                </div>
                <h5 className="x_user_name">
                  <span>{authorName}</span>
                  {/* <span className="text-span">Author</span> */}
                </h5>
              </div>
              <div className="x_comment_text x_comment_text--mini">
                {commentText}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const Metadata = withRouter(MetadataInner);
